import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as cafeDiscountActions from '../../../redux/cafeDiscounts/actions';
import CafeDiscountRequestsTable from './cafeDiscountRequestsTable';
import Spin from '../../../components/loading';
import Pagination2 from '../../../components/Pagination2';
import CafeDiscountRequestsFilter from './cafeDiscountRequestsFilter';
import submitForm from '../../../utils/submitForm';

class CafeDiscountRequests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortType: 'asc',
      sortBy: 'createdAt',
      currentPage: 1,
      cafeIds: [],
      itemsPerPage: 10,
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  applyFilters = event => {
    const filter = submitForm(event, [], [], this.state.cafeIds);
    this.setState({ filter }, () => this.filterAndSort());
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllCafeDiscountRequests(searchQuery);
    });
  };

  onSelectCafeIds = cafeIds => this.setState({ cafeIds: cafeIds ? [...cafeIds] : [] });

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllCafeDiscountRequests(query);
    });
  };

  render() {
    let {
      cafeDiscountRequestsLoading,
      cafeDiscountRequestsMessage,
      cafeDiscountRequestsFailed,
      cafeDiscountRequestsError,
    } = this.props;

    let { totalRecords } = this.props.cafeDiscountRequests;

    let { currentPage, itemsPerPage } = this.state;
    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            <div className="text-right">{locales('titles.cafeDiscountRequestsManagement')}</div>
          </h3>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={cafeDiscountRequestsLoading}>
            <article>
              <main className="panel panel-default">
                {cafeDiscountRequestsError ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {cafeDiscountRequestsFailed && (
                      <div className="alert alert-danger">{cafeDiscountRequestsMessage}</div>
                    )}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1"/>
                      {locales('titles.cafeDiscountRequestsList')}
                    </div>
                    <div className="panel-body">
                      <CafeDiscountRequestsFilter
                        onSelectCafeIds={this.onSelectCafeIds}
                        applyFilters={this.applyFilters}
                        filterAndSort={this.filterAndSort}
                        pageNumber={currentPage}
                      />
                      <CafeDiscountRequestsTable
                        sortType={this.state.sortType}
                        pageNumber={currentPage}
                        sortTable={this.sortTable}
                        pageSize={itemsPerPage}
                        buildSearchQuery={this.buildSearchQuery}
                      />
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    cafeDiscountRequestsList: state.cafeDiscountsReducer.cafeDiscountRequestsList,
    cafeDiscountRequests: state.cafeDiscountsReducer.cafeDiscountRequests,
    cafeDiscountRequestsLoading: state.cafeDiscountsReducer.cafeDiscountRequestsLoading,
    cafeDiscountRequestsMessage: state.cafeDiscountsReducer.cafeDiscountRequestsMessage,
    cafeDiscountRequestsFailed: state.cafeDiscountsReducer.cafeDiscountRequestsFailed,
    cafeDiscountRequestsError: state.cafeDiscountsReducer.cafeDiscountRequestsError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllCafeDiscountRequests: query => dispatch(cafeDiscountActions.fetchAllCafeDiscountRequests(query)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CafeDiscountRequests));
